export const constant = '';

export const transitions = {
  from: { opacity: 0, height: 0 },
  enter: { opacity: 1, height: 'auto' },
  leave: { opacity: 0, height: 0 },
  config: { duration: 100 }
};
